import { FC } from 'react'
import serverError from '../../../assets/images/server_error.png'
import error from '../../../assets/images/error.png'
import { StyledHeading, StyledDescription, StyledBox, StyledLink } from './ErrorPage.styles'
import { useTranslation } from 'react-i18next'
import { BoxProps } from '@mui/material'

export type Props = {
  returnToHomeLink?: string
  message?: string
  isServerError?: boolean
} & BoxProps

const ErrorPage: FC<Props> = ({ returnToHomeLink, message, isServerError = true, ...rest }) => {
  const { t } = useTranslation('shared', { keyPrefix: 'notFound' })

  return (
    <StyledBox {...rest}>
      <img src={isServerError ? serverError : error} alt="error" />
      <StyledHeading variant="h2">{t('sorry')}</StyledHeading>
      <StyledDescription>{message ?? t('missingOrBroken')}</StyledDescription>
      {returnToHomeLink && <StyledLink to={returnToHomeLink}>{t('returnHome')}</StyledLink>}
    </StyledBox>
  )
}

export default ErrorPage
